<template>
  <div class="page-content container-fluid">
    <div class="dashboard">
      <b-row>
        <b-col cols="12" md="6" lg="4"></b-col>
        <b-col cols="12">
          <div class="panel">
            <div class="panel-heading">
              <h3 class="panel-title">Trips</h3>
            </div>
            <div class="panel-body">
              <b-row class="justify-content-md-center">
                <b-col cols="12" :style="{'margin-top': '30px'}">
                  <b-pagination
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageLimit"
                    @change="changePage"
                  ></b-pagination>
                </b-col>
                <b-col cols="12">
                  <b-table striped hover :items="riders" :fields="riderFields" stacked="sm">
                    <template v-slot:cell(profilePictureUrl)="data">
                      <b-img v-bind="{width: 100, height: 100}" :src="data.item.profilePictureUrl" rounded="circle" alt="Not rounded image"></b-img>
                      
                    </template>
                    <template v-slot:cell(view)="data">
                      <b-button @click="openModal(data.item._id)">View</b-button>
                    </template>
                  </b-table>
                </b-col>
                <b-col cols="12">
                  <b-pagination
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageLimit"
                    @change="changePage"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import viewBooking from "@/components/bookings/view-booking";
import createBooking from "@/components/bookings/create-booking";
import { googleMap } from "@/components/google/index";

export default {
  name: "dashboard",
  components: {
    createBooking,
    viewBooking,
    googleMap
  },
  computed: {
    authUser() {
      return this.$store.getters["authUser/user"];
    }
  },
  data() {
    return {
      viewBookingId: null,
      openBooking: false,
      riders: [],
      pagination: {
        page: 1,
        pageLimit: 10
      },
      booking: {
        driver: {},
        rider: {}
      },
      riderFields: [
        {
          key: "profilePictureUrl",
          label: "Picture"
        },
        {
          key: "name",
          label: "Name"
        },
        {
          key: "email",
          label: "Email"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "rating",
          label: "Rating average"
        },
        {
          key: "view",
          label: "View"
        }
      ]
    };
  },
  async created() {
    this.getRiders();
  },
  methods: {
    // async openModal(bookingId) {
    //   this.booking = await shebahApi.api.bookings.get(bookingId);
    //   this.$refs.tripModal.show();
    // },
    changePage(pageNumber) {
      this.pagination.page = pageNumber;
      this.getRiders();
    },
    async getRiders() {
      // let riders = await shebahApi.api.bookings.list(
      //   this.pagination.page,
      //   this.pagination.pageLimit
      // );
      let rider = `{"profile":{"state":"QLD","address":"Queensland Ave, Broadbeach QLD 4218, Australia","city":"Broadbeach","postalCode":"4218","pictureUploadId":"5e4c6a2b9ca28a109e3c3653","profilePictureUrl":"https://files.shebah.com.au/upload/5e4c6a2b9ca28a109e3c3653/original.jpg"},"location":{"geo":[144.9846042,-37.7958269],"orientation":93.44092},"docStatus":{"hasPending":false,"hasExpired":false,"has1mExpiring":false,"has1wExpiring":false,"uploadCount":2},"accreditation":{"confirm":false,"status":"awaiting_approval","authority_no":"adsfsdf","front_upload_id":"5e3cb0d8f383b21002578754","expiryDateD":12,"expiryDateM":12,"expiryDateY":1212,"createdTs":"2020-02-07T00:35:36.653Z","uploadTs":"2020-02-07T00:35:36.653Z"},"drivingLicense":{"status":"awaiting_approval","uploadTs":"2020-02-17T22:30:22.856Z","statusBack":"awaiting_approval","number":"ergertert","front_upload_id":"5e4b13feb3c7940cf029f806","back_upload_id":"5e4b1400b3c7940cf029f807","expiryDateD":12,"expiryDateM":12,"expiryDateY":1212,"createdTs":"2020-02-17T22:30:22.856Z"},"workingWithChildrenCheck":{"uploadTs":"2020-02-13T02:10:59.000Z","status":"awaiting_approval"},"facilities":[],"_id":"5d5b7dde85d51a007c114811","status":"incomplete","updates":[{"status":"incomplete","ts":"2019-08-20T04:58:06.778Z"},{"status":"onboarded","ts":"2020-02-13T02:07:15.775Z"},{"status":"incomplete","ts":"2020-02-13T02:08:13.635Z"},{"status":"pending","ts":"2020-02-13T02:10:52.400Z"},{"status":"incomplete","ts":"2020-02-13T02:10:59.881Z"}],"firstName":"Henco","lastName":"Burger","email":"henco+1@shebah.com.au","phone":"+610000","referralCode":"WC6LUS","register_step":3,"termsAndConditionsConfirm":true,"femaleConfirm":true,"carConfirm":true,"acceptsAdvancedBooking":true,"acceptsAdvancedBookingOffline":true,"isAdvancedBookingFreeze":false,"updatedTs":"2020-02-18T04:41:56.001Z","createdTs":"2019-08-20T04:58:06.000Z","abn":"48 612 227 951","isFacilitiesFreeze":false,"shareholder":false,"car":"5dd6b962f32a6a156248ad13","vehicleAccreditation":{"front_upload_id":"","uploadTs":"2019-08-20T11:51:38.000Z","status":"awaiting_approval","authority_no":""},"remember_token":"DgyspOtvINpkLHrerbyeWd1LlDJcQAC79RC5KFUSBvBq2yTvBWSSXcqYdxEJ","business_name":"SHEBAH PTY LTD","gstRegistered":true,"isOnDuty":false,"lastActionTs":"2020-02-04T00:58:06.328Z","isHeadingHome":false,"pendingTs":"2020-02-13T02:06:52.023Z"}`
      
      for(let i = 0;i <= 10; i++) {
        
        this.riders.push(JSON.parse(rider));
      }

      this.riders = this.riderFactory(this.riders);
      
      this.pagination = {
        pageCount: 1,
        total: 10,
        page: 1,
        pageLimit: 10
      };
    },
    riderFactory(riders) {
      let newRiders = [];
      for (let rider of riders) {
        newRiders.push({
          profilePictureUrl: rider.profile.profilePictureUrl,
          name: `${rider.firstName} ${rider.lastName}`,
          email: rider.email,
          status: rider.status,
          rating: rider.status
        });
      }
      return newRiders;
    },
    getRiderstatus(status) {
      let statusEnum = {
        1: "New",
        2: "Assigned",
        3: "On Route",
        4: "Cancelled",
        5: "In Transit",
        6: "Completed",
        7: "Advanced",
        8: "Pending Payment"
      };

      return typeof statusEnum[status] !== "undefined"
        ? statusEnum[status]
        : "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.trip-preview {
  height: 150px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 25px;
}
.profile-image {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-position: center;
  background-size: cover;
}
</style>
